import { useAppDispatch, useAppSelector } from "hooks/redux";
import useReactHookForm from "hooks/useReactHookForm";
import { useEffect, useState } from "react";
import {
  areAllFieldsFilled,
  createStateLanguagePreInitialValues,
  createStateLanguagePreValidationSchema,
  createStateLanguageProperties,
  createStateLanguageSecPreInitialValues,
  createStateLanguageSecPreValidationSchema,
  createStateLanguageSecProperties,
} from "./helper";
import { Box, Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getGenericLanguageListData } from "utils/metadata-split/metaDataApiFetch";
import CreateDataTable from "./table/create-table";
import {
  getStatelanguagePrefListRequest,
  setFilterAfterUpdate,
} from "pages/configue/slices/language-preferance-slice";
import NoDataFound from "shared/molecules/no-data";
import Loader from "pages/build-test/loader";
import configueService from "pages/configue/service";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import LoadingButton from "@mui/lab/LoadingButton";
import { useHistory } from "react-router-dom";

export const CreateLanguagePre = () => {
  const [showSecondSection, setShowSecondSec] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    createStateLanguagePreInitialValues,
    createStateLanguagePreValidationSchema,
    ""
  );
  const {
    control: controlLang,
    errors: errorsLang,
    getValues: getValuesLang,
    watch: watchLang,
    setValue: setValueLang,
  } = useReactHookForm(
    createStateLanguageSecPreInitialValues,
    createStateLanguageSecPreValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [triggerSetValue, setTriggerSetValue] = useState(false);
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const { createPageStateLangPrefList, loading }: any = useAppSelector(
    (state) => state.languagePreferanceSlice
  );
  const [showLoading, setShowIsLoading] = useState(true);

  const updateMetaData = (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    dispatch(metadataSuccess(metadataList));
    setShowIsLoading(false);
  };

  const handleNext = () => {
    setShowSecondSec(true);
    const reqBody = {
      state_id: watch().state_id,
      board_id: watch().board_id,
      segment_id: watch().segment_id,
      class_id: watch().class_id,
    };
    dispatch(getStatelanguagePrefListRequest(reqBody));
  };

  const handleCreateLangPref = async () => {
    try {
      setBtnLoading(true);
      const reqBodyFirst = {
        state_id: watch().state_id,
        board_id: watch().board_id,
        segment_id: watch().segment_id,
        class_id: watch().class_id,
      };
      const reqBodymain = {
        ...reqBodyFirst,
        first_language_list: watchLang()?.first_language_list,
        second_language_list: watchLang()?.second_language_list,
        third_language_list: watchLang()?.third_language_list,
      };
      const res: any = await configueService.createStateLanguagePreferanceList(
        reqBodymain
      );
      if (res?.status === 200 && res?.data?.status === "success") {
        dispatch(snackbarRequest({ message: res.data.message }));
        setBtnLoading(false);
        dispatch(setFilterAfterUpdate(reqBodyFirst));
        history.push(`/configue/language_preferance`);
        // dispatch(getStatelanguagePrefListRequest(reqBodyFirst));
      } else {
        setBtnLoading(false);
        dispatch(snackbarRequest({ message: res.data.message, type: "error" }));
      }
    } catch (error: any) {
      setBtnLoading(false);
      dispatch(
        snackbarRequest({
          message: error?.response?.data?.message,
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    setShowIsLoading(true);
    (async () => {
      try {
        const call1: any = await getGenericLanguageListData(updateMetaData);
        updateMetaData(call1[0], call1[1]);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  if (showLoading) {
    return <p>loading....</p>;
  }
  return (
    <>
      <TypographyHeading>Create Language Preference</TypographyHeading>
      <Box>
        <Paper elevation={2} sx={{ px: 2, pb: 2, marginTop: "10px" }}>
          <Grid container spacing={2}>
            <DynamicForm
              fields={createStateLanguageProperties}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              watch={watch}
            />
            <ContentRight sx={{ mt: -1 }}>
              <Button
                variant="contained"
                sx={{
                  width: "70px",
                  height: "40px",
                  marginTop: "15px",
                  marginRight: "10px",
                  padding: "7px 42.5px 7px 48.5px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={handleNext}
                disabled={!areAllFieldsFilled([watch()])}
              >
                Next
              </Button>
            </ContentRight>
          </Grid>
        </Paper>
      </Box>
      {showSecondSection && loading && <Loader />}
      {showSecondSection && !loading && (
        <>
          <Box>
            <Paper elevation={2} sx={{ px: 2, pb: 2, marginTop: "30px" }}>
              <Grid container spacing={2}>
                <DynamicForm
                  fields={createStateLanguageSecProperties}
                  control={controlLang}
                  errors={errorsLang}
                  getValues={getValuesLang}
                  setValue={setValueLang}
                  watch={watchLang}
                />
                <ContentRight sx={{ mt: -7 }}>
                  <LoadingButton
                    variant="contained"
                    loadingPosition="start"
                    loading={btnLoading}
                    sx={{
                      width: "70px",
                      height: "40px",
                      marginTop: "15px",
                      marginRight: "10px",
                      padding: "7px 42.5px 7px 48.5px",
                      cursor: "pointer",
                      textAlign: "center",
                    }}
                    onClick={handleCreateLangPref}
                    disabled={!areAllFieldsFilled([watch(), watchLang()])}
                  >
                    create
                  </LoadingButton>
                </ContentRight>
              </Grid>
            </Paper>
          </Box>
        </>
      )}
      {showSecondSection &&
        !loading &&
        createPageStateLangPrefList?.length > 0 && (
          <Box
            sx={{
              overflowX: "auto",
              overflowY: "visible",
              width: "100%",
            }}
          >
            <CreateDataTable data={createPageStateLangPrefList} />
          </Box>
        )}
      {showSecondSection &&
        !loading &&
        createPageStateLangPrefList?.length == 0 && (
          <NoDataFound message="No List found, Please create new Language preference" />
        )}
    </>
  );
};
